import styled from "styled-components";
import { css } from "styled-components";
import { Flex } from "../Flex";
export const Heading = styled(Flex) ``;
export const Container = styled(Flex) `
  * {
    transition: all 0.3s ease-in-out;
  }

  ${Heading} {
    border: 1px solid var(--border-primary);
    background-color: var(--neutral-white);
    border-radius: 8px;

    i, p, svg * {
      color: var(--text-disable);
      fill: var(--text-disable);
    }
  }

  &[data-state="next"] {
    ${Heading} {
      border-color: var(--semantic-promo-text) !important;

      i, svg * {
        color: var(--semantic-promo-text);
        fill: var(--semantic-promo-text);
      }

      p {
        color: var(--text-primary);
      }
    }
  }

  ${({ onClick }) => onClick &&
    css `
    &:hover {
      ${Heading} {
        border-color: var(--semantic-promo-text);

        i, p, svg * {
          color: var(--text-primary);
        }
      }
    }
  `}

  &[data-state="active"] {
    ${Heading} {
      background-color: var(--semantic-promo-text);
      border-color: var(--semantic-promo-text);

      i, p, svg *, span {
        color: var(--neutral-white);
        fill: var(--neutral-white);
      }
    }
  }

`;
//# sourceMappingURL=styles.js.map